import { ContactText } from '../components/Contact';

const Contact = () => (
    // <>
        <ContactText />
    // </>
);

export default Contact;
